<template>
  <div id="home" class="home" :class="{ 'not-scrollable' : burgerActive }">

    <!-- PreLoader  -->
    <!-- <PreLoader @showContent="makeContentVisible" v-if="!preLoaderDone"/> -->

    <!-- Content to load  -->
    <div class="content" :class="{ 'visible' : preLoaderDone }">
      <Header @burgerClicked="changeBurgerStatus" :burgerMenuOpen="burgerActive" />

      <!-- da renderizzare se il dispositivo e' un mobile  -->
      <!-- da fare l' animazione e aggiustare per tablet il bordo bianco  -->
      <MobileMenu  :burgerMenuOpen="burgerActive" @linkClicked="closeBurger"/> 
      
      <AssistedBrands />
      <Services />
      <About />
      <WhereWeWork />
      <ContactUs />
      
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import AssistedBrands from '../components/AssistedBrands.vue';
import Services from '../components/Services.vue';
import MobileMenu from '../components/MobileMenu.vue';
import WhereWeWork from '../components/WhereWeWork.vue';
import ContactUs from '../components/ContactUs.vue';
import Footer from '../components/Footer.vue';
import About from '../components/About.vue';
// import PreLoader from '../components/PreLoader.vue';

export default {
  name: "Home",
  components: {
    // PreLoader,
    Header,
    AssistedBrands,
    Services,
    MobileMenu,
    WhereWeWork,
    ContactUs,
    About,
    Footer    
  },
  data: function() {
    return {
      burgerActive: false,
      preLoaderDone: true,
    }
  },
  methods: {
    changeBurgerStatus: function(headerHeigth) {
      this.burgerActive = !this.burgerActive;

      // Control margin and blur 
      const home = document.getElementById('home');
      if (this.burgerActive) {
        home.style.marginTop = headerHeigth + 'px';
        return;
      }

      // Reset margin  
      home.style.marginTop = '0px';

    },
    closeBurger: function() {

      // Resetting margin 
      const home = document.getElementById('home');
      home.style.marginTop = '0px';
 
      // CLosing burger 
      this.burgerActive = false;
    },
    makeContentVisible: function() {
      this.preLoaderDone = true;
    },
  }
};
</script>

<style lang="scss" scoped>
.home {

  &.not-scrollable {
    overflow: hidden;
  }

  .content {
    display: none;

    &.visible {
      display: block;
    }
  }
}
</style>
